'use strict'

import DateFromNowController from './vd-date-from-now.controller'

const DateFromNowComponent = {
  bindings: {
    date: '<',
  },
  controller: DateFromNowController,
  template: '{{$ctrl.dateFromNow}}',
}

export default DateFromNowComponent
